// Auth
export const ROUTING_LOGIN = "/login";

// Dashboard
export const ROUTING_MMM_MODEL = "/mmm-model";
export const ROUTING_SIMULATOR = "/simulator";
export const ROUTING_ADMIN_PANEL = "/admin";
export const ROUTING_HOME = "/";

const ROUTES = {
  HOME: ROUTING_HOME,
  MMM_MODEL: ROUTING_MMM_MODEL,
  SIMULATOR: ROUTING_SIMULATOR,
  ADMIN_PANEL: ROUTING_ADMIN_PANEL
};

export default ROUTES;
